import * as React from 'react';

import {Button} from 'shells/button/button';

import type {View, MergeTagOption} from './add-merge-field';

import styles from './add-merge-field-header.module.css';

type Props = {
    currentView: View;
    setCurrentView: (newView: View) => void;
    setSearchValue: (arg1: string) => void;
    setSelectedMergeTag: (arg1?: MergeTagOption | null | undefined) => void;
};

export function AddMergeFieldHeader(props: Props) {
    const {currentView, setCurrentView, setSearchValue, setSelectedMergeTag} = props;

    const getAddText = () => {
        if (currentView === 'standard') {
            return <p className={styles.title}>Add a merge tag</p>;
        }

        return (
            <Button
                variant='text-secondary'
                size='big'
                onClick={() => {
                    setSelectedMergeTag(null);
                    setSearchValue('');
                    setCurrentView('standard');
                }}
            >
                <p className={styles.title}>Add a merge tag</p>
            </Button>
        );
    };

    const getTitle = () => {
        if (currentView === 'custom') {
            return (
                <>
                    <span className={styles.arrow}>&gt;</span>
                    <p className={styles.title}>Custom fields</p>
                </>
            );
        }
    };

    return (
        <div className={styles.header}>
            <div className={styles.top}>
                <div className='flex align-center'>
                    {getAddText()}
                    {getTitle()}
                </div>
            </div>
        </div>
    );
}
